module.exports = __webpack_public_path__ + "img/MegaPromo_Carousel_Desktop_24_03.1399f867.jpg";